export default {
    tooltip: {
        trigger: 'item',
        /**
         * a => series.name
         * b => legend[i]
         * c => series.data[i].value
         * d => media
         */
        formatter: "{a} <br/>{b}: {c} ({d}%)"
    },
    legend: {
        orient: 'vertical',
        x: 'right',
        data: ['rojo','azul oscuro','azul claro','salmon','verde vue']
    },
    series: [
        {
            name: 'Graficas de prueba',
            type: 'pie',
            radius: ['50%', '60%'],
            // avoidLabelOverlap: false,
            label: {
                normal: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    show: true,
                    textStyle: {
                        fontSize: '30',
                        fontWeight: 'bold'
                    }
                }
            },
            labelLine: {
                normal: {
                    show: false
                }
            },
            data:[
                { value: 335, name: 'rojo' },
                { value: 310, name: 'azul oscuro' },
                { value: 234, name: 'azul claro' },
                { value: 135, name: 'salmon' },
                { value: 1548, name: 'verde vue' }
            ]
        }
    ]
}